module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('header', {
    staticClass: "header-area single-page yincang"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container header912"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "diannao-sous"
  }, [_c('img', {
    staticStyle: {
      "width": "18px",
      "margin-top": "25px",
      "display": "inline-block",
      "cursor": "pointer"
    },
    attrs: {
      "src": require("../static/assets/images/sech.png")
    },
    on: {
      "click": _vm.toggleVisibility
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "custom-navbar sandaogang",
    on: {
      "click": function($event) {
        _vm.isVisibleb = _vm.flase
      }
    }
  }, [_c('span', {
    staticStyle: {
      "height": "2px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "height": "1px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "height": "2px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', [(!_vm.isVisible) ? _c('div', {
    staticClass: "custom-navbarc",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "background": "rgb(0 0 0 / 8%)",
      "position": "fixed",
      "z-index": "-4",
      "left": "0px",
      "bottom": "0px"
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._l((_vm.daohanglist), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": item.gnote
      },
      nativeOn: {
        "click": function($event) {
          return _vm.reloadPage.apply(null, arguments)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.son.length > 0) ? _c('ul', {
      staticClass: "sub-menu"
    }, [_c('div', {
      staticClass: "toubu_ziti2",
      staticStyle: {
        "color": "#FFFFFF",
        "font-size": "30px"
      }
    }, [_vm._v("\n                        " + _vm._s(item.name) + " / "), _c('span', {
      staticStyle: {
        "font-size": "18px",
        "font-weight": "500"
      }
    }, [_vm._v(_vm._s(item.filename))]), _vm._v(" "), _c('p', {
      staticClass: "toubu_ziti1",
      staticStyle: {
        "font-size": "16px",
        "line-height": "50px",
        "color": "#ffffffad"
      }
    }, [_vm._v("\n                          专注于工业自动化测控领域的应用产品开发与技术服务\n                        ")])]), _vm._v(" "), _vm._l((item.son), function(itema, indexa) {
      return _c('li', {
        key: indexa
      }, [_c('router-link', {
        attrs: {
          "to": itema.gnote
        },
        nativeOn: {
          "click": function($event) {
            return _vm.reloadPage.apply(null, arguments)
          }
        }
      }, [_vm._v(_vm._s(itema.name))])], 1)
    }), _vm._v(" "), _vm._m(3, true)], 2) : _vm._e()], 1)
  })], 2), _vm._v(" "), (_vm.isVisibleb) ? _c('div', {
    staticClass: "diannao-sous-kuang"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyValue),
      expression: "keyValue"
    }],
    staticClass: "inputValue",
    staticStyle: {
      "background-color": "transparent",
      "border": "solid 1px white",
      "font-size": "14px",
      "color": "white",
      "height": "36px",
      "padding": "6px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入内容"
    },
    domProps: {
      "value": (_vm.keyValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "login",
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "line-height": "35px",
      "padding": "0px 10px",
      "border-radius": "5px",
      "background": "#007bff"
    },
    attrs: {
      "to": {
        path: '/yingyong',
        query: {
          key: _vm.keyValue
        }
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reloadPage.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                        搜索\n                      ")])], 1) : _vm._e()])])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "footer-area section-padding"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "22px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container weibu912",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(6)])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner"
  }, [_vm._v("拿度")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-area"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/logoc.png",
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("网站首页")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toubu_tubiao",
    staticStyle: {
      "float": "right",
      "top": "100px",
      "position": "absolute",
      "right": "10%"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/bailogo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36d4addc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 102
// module chunks = 0